export default function Footer() {
  return (
    <div className="Footer">
      <p className="footer-text">Made by: Julio Pacheco</p>
    </div>
  );
}
